VjsAdmin.DistrictGroupBulkUploadErrors = (function () {
    const me = {};

    const $table = $('#bulk-upload-errors-table');
    me.platform_id = $table.attr('data-platform-id');
    me.district_joint_guid = $table.attr('data-district-joint-guid');
    me.bulk_upload_id = $table.attr('data-bulk-upload-id');

    const init = function () {
        initBulkUploadErrorsTable();
    };

    const initBulkUploadErrorsTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#bulk-upload-errors-table',
            formatNoMatches() {
                return 'No errors for this bulk upload.';
            },
            idField: 'user_bulk_upload_error_id',
            sortName: 'date_of_error',
            sortOrder: 'asc',
            showRefresh: false,
            toolbarAlign: 'right',
            url: Slim.Router.pathFor('platforms.districts.groups.bulkuploads.errors.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
                bulk_upload_id: me.bulk_upload_id,
            }),
            pageList: [5, 10, 20, 50, 100, 200],
            columns: [
                {
                    title: 'Username',
                    field: 'username',
                    align: 'center',
                    valign: 'middle',
                    class: 'status',
                    sortable: true,
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Password',
                    field: 'password',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Grade',
                    field: 'grade',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Graduation Year',
                    field: 'graduation_year',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Role',
                    field: 'role',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Error',
                    field: 'error_message',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Date',
                    field: 'date_of_error',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    if (row.role === '') {
                        row.role = 'student';
                    }
                    if (row.password != null) {
                        row.password = `<a href="#" class="click-reveal" data-value="${row.password}"><i class="fa fa-eye" aria-hidden="true"></i></a>`;
                    }
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
